<template>
    <el-container v-loading="loading" width="1200px" height="800px">
        <el-header align="left" style="margin-top: 10px;">
            <el-row :gutter="20">
                <el-col :span="12" align="left">
                    <el-button type="primary" :disabled="timeExpirationDisabled()" @click="handleDeviceListModalShow">
                        {{$t('home.buttonCompetitors')}}
                    </el-button>
                    <el-button type="primary" @click="handleCreateEvent" :disabled="timeExpirationDisabled()"
                               icon="el-icon-circle-plus-outline">
                        {{$t('home.buttonEvent')}}
                    </el-button>
                    <el-button type="primary" @click="$refs.fileInput.click()" :disabled="trackLoadDisabled()"
                               icon="el-icon-circle-plus-outline">
                        <input ref="fileInput" style="display: none" type="file" type.native="file"
                               @change="loadGpxFile($event)">{{$t('home.buttonTrack')}}
                    </el-button>
                    <el-button type="primary" @click="handleEditRaceModalShow(null);" icon="el-icon-circle-plus-outline"
                               :disabled="!this.selectedEvent">{{$t('home.buttonAction')}}
                    </el-button>
                </el-col>
                <el-col :span="6" align="left">
                    <el-select v-model="locale" placeholder="Select">
                        <el-option
                                v-for="item in $data.availableLanguage"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="6" align="right">
                    <a href="https://1rpu.ru">
                        <img src="/logo_1rpu.jpeg" height="72px" style="border: 0;">
                    </a>
                </el-col>
            </el-row>
        </el-header>
        <el-main>
            <div>
                <el-row :gutter="20" style="height: calc(100vh - 200px)">
                    <el-col :span="11" style="width: 49.9%;">
                        <div class="filter_bar">
                            <div class="filter_block">
                                <label for="">{{$t('home.eventGrid.eventYear')}}: </label>
                                <el-select v-model="selectedYear"
                                           :placeholder="$t('home.eventGrid.eventYearPlaceHolder')">
                                    <el-option
                                            v-for="item in availableYears"
                                            :key="item"
                                            :label="item"
                                            :value="item">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="filter_block search_filter">
                                <label for="">{{$t('home.eventGrid.eventSearch')}}: </label>
                                <el-input
                                        :placeholder="$t('home.eventGrid.eventSearchPlaceHolder')"
                                        v-model="searchString" clearable>
                                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                </el-input>
                            </div>
                        </div>
                        <el-container align="top">
                            <el-table style="height: calc(100vh - 200px); overflow: scroll;"
                                      :data="events"
                                      ref="eventTable"
                                      highlight-current-row
                                      @row-dblclick="handleEditEvent"
                                      @row-click="eventSelected"
                                      @selection-change="handleSelectionChange"
                                      align="top"
                                      :empty-text="$t('common.emptyText')">
                                <el-table-column type="expand">
                                    <template slot-scope="props">
                                        <p>Клуб: <b>{{ props.row.club == undefined?'': props.row.club.name}}</b></p>
                                        <!--<p>{{ JSON.stringify(props.row)}}}</p>-->
                                        <p>Тип: {{ props.row.type == undefined?'':props.row.type.name }}</p>
                                        <p>Участников: {{ arraySize(props.row.competitors) }}</p>
                                        <p>Яхт: {{ arraySize(props.row.boats) }}</p>
                                        <p>Гонок\Треков: {{ arraySize(props.row.races) }}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="eventStart"
                                        :label="$t('home.eventGrid.columnStart')"
                                        :formatter="dateFormat"
                                        width="100px">
                                </el-table-column>
                                <el-table-column
                                        prop="eventEnd"
                                        :label="$t('home.eventGrid.columnFinish')"
                                        :formatter="dateFormat"
                                        width="100px">
                                </el-table-column>
                                <el-table-column
                                        prop="name"
                                        :label="$t('home.eventGrid.columnEvent')">
                                </el-table-column>
                                <el-table-column
                                        align="right">
                                    <template slot-scope="scope">
                                        <el-tooltip :content="$t('home.eventGrid.eventDelete')" placement="top"
                                                    effect="light">
                                            <el-button
                                                    icon="el-icon-delete"
                                                    type="text"
                                                    size="medium"
                                                    @click="handleDeleteEvent(scope.row)"
                                            ></el-button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-container>
                    </el-col>
                    <el-col :span="2"
                            style="padding-left: 0px!important; padding-right: 0px; height: calc(100vh - 165px); border-radius: 0px; width: 1px">
                        <div style="border-right: 1px solid #000;height: 100%;"></div>
                    </el-col>
                    <el-col :span="11" style="width: 49.9%;">
                        <el-switch
                                style="display: block"
                                v-model="$data.showRaces"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                :active-text="$t('home.raceType.race')"
                                :inactive-text="$t('home.raceType.track')"
                                @change="raceTypeSelected">
                        </el-switch>
                        <el-container>
                            <el-table :data="races"
                                      style="height: calc(100vh - 200px); overflow: scroll;"
                                      empty-text="Нет данных"
                                      :row-class-name="tableRowClassName"
                                      @row-dblclick="handleEditRaceModalShow">
                                <el-table-column type="expand">
                                    <template slot-scope="props">
                                        <p>Название: {{ props.row.name }}</p>
                                        <p>Начало: {{ dateTimeFormat(null,null,props.row.trackStart) }}</p>
                                        <p>Завершение: {{ dateTimeFormat(null,null,props.row.trackEnd) }}</p>
                                        <p>Тип: {{ props.row.type.name }}</p>
                                        <p>Участников: {{ arraySize(props.row.entrys) }}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="raceStart"
                                        :label="$t('home.raceGrid.columnStart')"
                                        :formatter="dateTimeFormat"
                                        width="130">
                                </el-table-column>
                                <el-table-column
                                        prop="name"
                                        :label="$t('home.raceGrid.columnAction')">
                                </el-table-column>
                                <el-table-column
                                        align="right">
                                    <template slot-scope="scope">
                                        <el-tooltip :content="$t('home.raceGrid.eventViewStatistic')" placement="top"
                                                    effect="light">
                                            <el-button
                                                    icon="el-icon-time"
                                                    @click="handleRaceStatModalShow(scope.row);"
                                                    :disabled="isStatisticEnabled(scope.row)"
                                                    type="text"
                                                    size="medium"
                                            ></el-button>
                                        </el-tooltip>
                                        <el-tooltip :content="$t('home.raceGrid.eventCalculateStatistic')"
                                                    placement="top" effect="light">
                                            <el-button
                                                    icon="el-icon-setting"
                                                    @click="handleCalculateRaceStatistic(scope.row);"
                                                    :disabled="isTrack(scope.row)"
                                                    type="text"
                                                    size="big"
                                            ></el-button>
                                        </el-tooltip>
                                        <el-tooltip :content="$t('home.raceGrid.eventViewRace')" placement="top"
                                                    effect="light">
                                            <el-button
                                                    icon="el-icon-view"
                                                    @click="handleRaceCesiumModalShow(scope.row);"
                                                    type="text"
                                                    size="medium"
                                            ></el-button>
                                        </el-tooltip>
                                        <el-tooltip :content="$t('home.raceGrid.eventCopyLink')" placement="top"
                                                    effect="light">
                                            <el-button
                                                    icon="el-icon-share"
                                                    @click="handleRaceCesiumCopyLink(scope.row);"
                                                    type="text"
                                                    size="medium"
                                            ></el-button>
                                        </el-tooltip>
                                        <el-tooltip :content="$t('home.raceGrid.eventDeleteRace')" placement="top"
                                                    effect="light">
                                            <el-button
                                                    icon="el-icon-delete"
                                                    type="text"
                                                    size="medium"
                                                    @click="handleDeleteRace(scope.row)"
                                                    :disabled="isTrack(scope.row)"
                                            ></el-button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-container>
                    </el-col>
                </el-row>
            </div>
        </el-main>
        <el-footer align="left">
            <el-row :gutter="20">
                <el-col :span="16" align="left">
                    <div class="block">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :page-sizes="[10, 20, 30, 40, 50]"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="eventTableTotal">
                        </el-pagination>
                    </div>
                </el-col>
                <el-col :span="8" align="right">
                    <a href="http://regattascope.ru/">
                        <img src="/logo.png" height="40px">
                    </a>
                </el-col>
            </el-row>
        </el-footer>
        <race-cesium-modal
                v-if="raceCesiumModalVisible"
                :dialog-visible="raceCesiumModalVisible"
                @visible-change="
                    _visible => {
                      raceCesiumModalVisible = _visible;
                    }
                  "
                @on-close="handleRaceCesiumModalClose"
                :data="selectedRace">
        </race-cesium-modal>
        <track-cesium-modal
                v-if="trackCesiumModalVisible"
                :dialog-visible="trackCesiumModalVisible"
                @visible-change="
                    _visible => {
                      trackCesiumModalVisible = _visible;
                    }
                  "
                @on-close="handleTrackCesiumModalClose"
                :data="tracks">
        </track-cesium-modal>
        <race-statistic-modal
                v-if="raceStatisticModalVisible"
                :dialog-visible="raceStatisticModalVisible"
                @visible-change="
                    _visible => {
                      raceStatisticModalVisible = _visible;
                    }
                  "
                @on-close="handleRaceStatModalClose"
                :data="selectedRace">
        </race-statistic-modal>
        <event-edit-modal
                v-if="eventEditModalVisible"
                :dialog-visible="eventEditModalVisible"
                @visible-change="
            _visible => {
            eventEditModalVisible = _visible;
            }
            "
                @on-close="handleEventEditModalClose"
                :data="editableEvent">
        </event-edit-modal>
        <device-list-modal
                v-if="deviceListModalVisible"
                :dialog-visible="deviceListModalVisible"
                @visible-change="
            _visible => {
            deviceListModalVisible = _visible;
            }
            "
                @on-close="handleDeviceListModalClose">
        </device-list-modal>
        <edit-race-modal
                v-if="editRaceModalVisible"
                :dialog-visible="editRaceModalVisible"
                @visible-change="
            _visible => {
            editRaceModalVisible = _visible;
            }
            "
                @on-close="handleEditRaceModalClose"
                :data="selectedEvent">
        </edit-race-modal>
    </el-container>
</template>

<style>
    .el-row {
        margin-bottom: 20px;

    &
    :last-child {
        margin-bottom: 0;
    }

    }
    .el-col {
        border-radius: 4px;
    }

    .bg-purple-dark {
        background: #99a9bf;
    }

    .bg-purple {
        background: #d3dce6;
    }

    .bg-purple-light {
        background: #e5e9f2;
    }

    .grid-content {
        border-radius: 4px;
        min-height: 36px;
    }

    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }

    .file-select > input[type="file"] {
        display: none;
    }

    .el-table .race-row {
        /*background: oldlace;*/
    }

    .el-table .track-row {
        background: oldlace;
    }

    .el-table .trening-row {
        background: #f0f9eb;
    }

    .el-table .monitoring-row {
        background: #f0f9eb;
    }

    .el-button--medium {
        padding: 10px 15px;
    }

    .el-switch {
        height: 36px;
        font-size: 16px;
    }

    .el-switch__label * {
        font-size: 16px;
        font-weight: 300;
    }

    .filter_bar .filter_block {
        width: 30%;
        display: inline-block;
    }

    .filter_bar .filter_block .el-select {
        width: 70%;
    }

    .filter_bar .filter_block.search_filter {
        width: 70%;
    }

    .filter_bar .filter_block .el-input--medium {
        width: 83%;
    }
</style>

<script>
    import Vue from 'vue';
    import {format, getISOYear, addDays, parse, isBefore} from 'date-fns';
    import RaceUtils from '@/api/race';
    import EventUtils from '@/api/event';
    import RaceCesiumModal from './modal/RaceCesiumModal';
    import RaceStatisticModal from './modal/RaceStatisticModal';
    import EventEditModal from './modal/EventEditModal';
    import TrackCesiumModal from './modal/TrackCesiumModal';
    import DeviceListModal from "./modal/DeviceListModal";
    import EditRaceModal from './modal/EditRaceModal';
    import Utils from '@/utils';
    import {loadLanguageAsync, availableLanguage} from '@/i18n-setup';
    import TrackUtils from '@/api/track';
    import IntegrationUtils from '@/api/integration';
    import LoginUtils from '@/api/login';
    import {publicRaceUrl} from "@/api/base";

    import Clipboard from 'v-clipboard';

    Vue.use(Clipboard);

    export default {
        name: 'home',
        components: {
            DeviceListModal,
            RaceCesiumModal,
            RaceStatisticModal,
            EventEditModal,
            TrackCesiumModal,
            EditRaceModal
        },
        data() {
            return {
                events: [],
                races: [],
                loading: true,
                eventTableOffset: 0,
                eventTableLimit: 10,
                eventTableTotal: 0,
                selectedRace: null,
                selectedEvent: null,
                editableEvent: null,
                raceCesiumModalVisible: false,
                raceStatisticModalVisible: false,
                eventEditModalVisible: false,
                tracks: {files: null, selectedEvent: null},
                trackCesiumModalVisible: false,
                deviceListModalVisible: false,
                createRaceModalVisible: false,
                editRaceModalVisible: false,
                showRaces: true,
                locale: 'ru',
                availableLanguage: availableLanguage,
                availableYears: [],
                selectedYear: null,
                searchString: '',
                totalLoadTracks: null,
                maxLoadTraks: 500,
                expirationDate: addDays(new Date(), 7)
            }
        },
        created() {
            EventUtils.getIntervals().then(response => {
                let firstYear = getISOYear(new Date(response.data.firstDate));
                let lastYear = getISOYear(new Date(response.data.lastDate));
                let year;
                for (year = firstYear; year <= lastYear; year++) {
                    this.availableYears.unshift(year);
                }
                this.selectedYear = this.availableYears[0];
            }).catch(error => {
                console.log(error);
                this.availableYears.unshift(getISOYear(new Date()));
                this.selectedYear = this.availableYears[0];
            });
            TrackUtils.countTracks().then(response => {
                this.totalLoadTracks = response.data;
            });
            if (localStorage.getItem('user') == null || localStorage.getItem('user') == undefined) {
                console.log("User: " + localStorage.getItem('user'));
                LoginUtils.findUser().then(_ => {
                    console.log("User2: " + localStorage.getItem('user'));
                    this.updateUserRestriction();
                });
            } else {
                this.updateUserRestriction();
            }
        },
        watch: {
            locale: {
                immediate: true,
                handler(newVal, oldVal) {
                    loadLanguageAsync(newVal);
                }
            },
            selectedYear: {
                immediate: false,
                handler(newVal, oldVal) {
                    this.eventTableOffset = 0;
                    this.doEvents();
                }
            },
            searchString: {
                immediate: false,
                handler(newVal, oldVal) {
                    if ((newVal == null || newVal == undefined || newVal == '') || (newVal != null && newVal != undefined && newVal.length > 3)) {
                        this.doEvents();
                    }
                }
            }
        },
        methods: {
            doEvents: function () {
                let _this = this;
                this.loading = true;
                let dateStart = new Date(this.selectedYear, 0, 1, 0, 0, 0);
                let dateFinish = new Date(this.selectedYear, 11, 31, 23, 59, 59);
                EventUtils.getEvents(this.eventTableOffset, this.eventTableLimit, dateStart, dateFinish, this.searchString).then(response => {
                    _this.eventTableTotal = response.total;
                    _this.events = response.data;
                    let row;
                    let arr = [];
                    if (_this.selectedEvent != null && _this.selectedEvent != undefined) {
                        arr = _this.events.filter((item) => {
                            if (item.id === _this.selectedEvent.id) {
                                return item;
                            }
                        });
                    }
                    if (arr.length > 0) {
                        row = arr[0];
                    } else {
                        row = _this.events[0];
                    }
                    _this.eventSelected(row);
                    _this.$refs.eventTable.setCurrentRow(row);
                }).catch(error => {
                    console.log(error.toString());
                }).finally(() => {
                    this.loading = false;
                });
            },
            raceTypeSelected: function (val) {
                this.$data.showRaces = val;
                this.eventSelected();
            },
            eventSelected: function (row) {
                if (row != undefined && row != null) {
                    this.selectedEvent = row;
                }
                if (this.selectedEvent != undefined && this.selectedEvent != null && this.selectedEvent.races != undefined && this.selectedEvent.races != null) {
                    let show = this.$data.showRaces;
                    this.races = this.selectedEvent.races.filter((item) => {
                        if (show) {
                            return !Utils.raceIsTrackType(item);
                        } else {
                            return Utils.raceIsTrackType(item);
                        }
                    });
                } else {
                    this.races = null;
                }
            },
            dateFormat: function (row, column, cellValue) {
                if (cellValue == undefined) return '';
                return format(new Date(cellValue), this.$t('common.dateFormatTemplate'));
            },
            timeFormat: function (row, column, cellValue) {
                if (cellValue == undefined) return '';
                return format(new Date(cellValue), 'HH:mm.ss');
            },
            dateTimeFormat: function (row, column, cellValue) {
                if (cellValue == undefined) return '';
                return format(new Date(cellValue), this.$t('common.dateTimeFormatTemplate'));
            },
            handleSizeChange: function (val) {
                this.eventTableLimit = val;
                this.eventTableOffset = 0;
                this.races = [];
                //this.doEvents();
                this.handleCurrentChange(1);
            },
            handleCurrentChange: function (val) {
                if (val === 1) {
                    this.eventTableOffset = 0;
                } else {
                    this.eventTableOffset = (val - 1) * this.eventTableLimit;
                }
                this.races = [];
                this.doEvents();
            },
            handleSelectionChange(val) {
                this.selectedEvent = val;
            },
            handleRaceCesiumModalShow: function (data) {
                this.selectedRace = Object.assign({}, data);
                console.log('Show Race Cesium Modal');
                this.raceCesiumModalVisible = true;
            },
            handleRaceCesiumCopyLink: function (data) {
                this.$clipboard(publicRaceUrl + data.id);
                this.$message({
                    type: 'info',
                    message: this.$t('common.linkCopyed')
                });
            },
            handleRaceCesiumModalClose: function () {
                console.log('Close Race Cesium Modal');
                this.raceCesiumModalVisible = false;
            },
            handleTrackCesiumModalShow: function (data) {
                this.tracks.files = data;
                this.tracks.selectedEvent = this.selectedEvent;
                console.log('Show Track Cesium Modal');
                this.trackCesiumModalVisible = true;
            },
            handleTrackCesiumModalClose: function (data) {
                this.tracks.files = null;
                console.log('Close Track Cesium Modal');
                this.$refs.fileInput.value = '';
                this.trackCesiumModalVisible = false;
                if (data != null) {
                    this.doEvents();
                }
            },
            handleRaceStatModalShow(data) {
                this.selectedRace = Object.assign({}, data);
                console.log('Show Race Statistic Modal');
                this.raceStatisticModalVisible = true;
            },
            handleCalculateRaceStatistic: function (data) {
                this.loading = true;
                this.selectedRace = Object.assign({}, data);
                RaceUtils.calculateRaceStatistic(this.selectedRace.id)
                    .then(response => {
                        console.log('==> ' + this.selectedRace.id);
                        for (var item in this.races) {
                            console.log('\t' + this.races[item].id);
                            if (this.races[item].id === this.selectedRace.id) {
                                console.log(' find ' + this.races[item].id);
                                Vue.set(this.races[item], 'statAvailable', true);
                                this.handleRaceStatModalShow(data);
                                break;
                            }
                        }
                    })
                    .catch(e => {
                        console.log(e);
                        return e;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            handleCreateEvent: function () {
                this.handleEventEditModalShow({eventName: '', eventRange: []});
            },
            handleEditEvent: function (row) {
                this.handleEventEditModalShow({
                    id: row.id,
                    eventName: row.name,
                    eventRange: [row.eventStart, row.eventEnd]
                });
            },
            handleEventEditModalShow: function (val) {
                this.editableEvent = val;
                console.log('Show Event edit Modal');
                this.eventEditModalVisible = true;
            },
            handleEventEditModalClose: function (data) {
                this.editableEvent = null;
                console.log('Close Event edit Modal');
                this.eventEditModalVisible = false;
                if (data != null) {
                    this.doEvents();
                }
            },
            loadGpxFile: function ({target}) {
                this.$nextTick(_ => {
                    console.log('Loaded file ' + target.files[0].name);
                    this.handleTrackCesiumModalShow(target.files);
                });
            },
            handleDeviceListModalShow: function () {
                console.log('Show Device List Modal');
                this.deviceListModalVisible = true;
            },
            handleDeviceListModalClose: function () {
                console.log('Close Device List Modal');
                this.deviceListModalVisible = false;
            },
            arraySize: function (val) {
                if (Array.isArray(val)) {
                    return val.length;
                } else {
                    return null;
                }
            },
            tableRowClassName({row, rowIndex}) {
                return Utils.tableRowClassName({row, rowIndex});
            },
            isTrack: function (row) {
                return row.type.id == 3;
            },
            isStatisticEnabled: function (row) {
                return !(row.type.id == 1 && row.statAvailable == true);
            },
            handleEditRaceModalShow: function (row) {
                if(row != null && row.type.id == 3) {
                    this.handleRaceCesiumModalShow(row);
                    return;
                }
                if (this.selectedEvent != null && this.selectedEvent != undefined) {
                    this.selectedEvent.editableRace = row;
                }
                console.log('Show Edit Race Modal');
                this.editRaceModalVisible = true;
            },
            handleEditRaceModalClose: function (data) {
                console.log('Close Edit Race Modal');
                this.editRaceModalVisible = false;
                if (data != null) {
                    this.doEvents();
                }
            },
            handleDeleteRace: function (row) {
                this.$confirm(this.$t('home.deleteRace.message') + row.name + '"?', this.$t('home.deleteRace.header'), {
                    confirmButtonText: this.$t('common.buttonYes'),
                    cancelButtonText: this.$t('common.buttonNo'),
                    center: true,
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    RaceUtils.DELETE(row.id).then(response => {
                        this.loading = false;
                        this.$message({
                            type: 'success',
                            message: this.$t('home.deleteRace.success')
                        });
                        this.doEvents();
                    }).catch(error => {
                        this.$message({
                            type: 'error',
                            message: this.$t('home.deleteRace.error') + row.name + '! ' + error.toString()
                        });
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('common.deleteCanceled')
                    });
                });
            },
            handleDeleteEvent: function (row) {
                this.$confirm(this.$t('home.deleteEvent.message') + row.name + '"?', this.$t('home.deleteEvent.header'), {
                    confirmButtonText: this.$t('common.buttonYes'),
                    cancelButtonText: this.$t('common.buttonNo'),
                    center: true,
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    EventUtils.DELETE(row.id).then(response => {
                        this.loading = false;
                        this.$message({
                            type: 'success',
                            message: this.$t('home.deleteEvent.success')
                        });
                        this.doEvents();
                    }).catch(error => {
                        this.$message({
                            type: 'error',
                            message: this.$t('home.deleteEvent.error') + row.name + '! ' + error.toString()
                        });
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('common.deleteCanceled')
                    });
                });
            },
            trackLoadDisabled: function () {
                if (this.selectedEvent == null || this.selectedEvent == undefined) {
                    return true;
                } else {
                    if (isBefore(new Date(), this.expirationDate)) {
                        if (this.totalLoadTracks != null && this.totalLoadTracks < this.maxLoadTraks) {
                            return false;
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                }
            },
            timeExpirationDisabled: function () {
                return !isBefore(new Date(), this.expirationDate);
            },
            updateUserRestriction: function () {
                IntegrationUtils.getRestrictions().then(response => {
                    console.log(response);
                    this.maxLoadTraks = response.data.track_count;
                    this.expirationDate = parse(response.data.track_time);
                });
            }
        }
    }
</script>
